import { getLogger } from './../../api/logger-with-context'
import { getTokenSilently } from './auth0/auth0-functions'
import { httpClient as fetch } from '#lib/http-client'
import { localeHeader } from '#constants'

const getLastOrdersForUser = async (baseUrl, locale, orderType) => {
  const accessToken = await getTokenSilently()
  const response = await fetch(
    `${baseUrl}/v1/orders?limit=1&orderType=${orderType}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [localeHeader]: locale
      },
      json: true
    }
  )
  if (!response.ok) {
    const error = new Error(response.statusText)
    error.response = response
    throw error
  }
  return response.json()
}

const getOrderDetails = async (baseUrl, orderID, bag) => {
  const accessToken = await getTokenSilently()
  const response = await fetch(
    `${baseUrl}/v1/orders/${orderID}/lineitems/recalculated?pret-shop-id=${bag.orderDetails.fulfillingShopId}&pickup-time-start=${bag.orderDetails.pickupTimeStart}&pickup-time-end=${bag.orderDetails.pickupTimeEnd}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${accessToken}`,
        [localeHeader]: bag.locale
      },
      json: true
    }
  )
  if (!response.ok) {
    const error = new Error(response.statusText)
    error.response = response
    throw error
  }
  return response.json()
}

export const getLastOrder = async (baseUrl, bag) => {
  const logRef = 'Get Last Order::'
  const log = getLogger()
  try {
    log.info(`${logRef} get last order for user`)
    const orderType = bag.orderDetails?.orderType
    const orders = await getLastOrdersForUser(baseUrl, bag.locale, orderType)
    if (orders.length === 0) {
      return []
    }

    log.info({ lastOrderID: orders[0].orderId }, `${logRef} get last order ID`)
    const lastOrderDetails = await getOrderDetails(
      baseUrl,
      orders[0].orderId,
      bag
    )
    return lastOrderDetails
  } catch (error) {
    log.error({ error }, `${logRef} error`)
    return []
  }
}
